import { useEffect } from 'react';

const BASE = 'AgilizaOS';

/** Atualiza o título do separador do browser (acessibilidade e orientação). */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title.trim() ? `${BASE} · ${title.trim()}` : BASE;
    return () => {
      document.title = BASE;
    };
  }, [title]);
}
